<div class="flex position-relative full-width slide-out" [class.slide]="slideOut">
    <div class="flex full-width overlay"></div>

    <div class="flex flex-column full-width inner-slide-component">
        <div class="flex flex-column flex-grow full-width content-container overflow-y-scroll">
            <ng-content></ng-content>
            <ng-content select="[overflow]"></ng-content>
        </div>

        <button (click)="slideIn()" class="close-button">
            <i class="fa-solid fa-close" aria-hidden="true"></i>
        </button>
    </div>
</div>
